var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE = {
    MEDICAL_POST: 'MEDICAL_POST',
    RESOURCE: 'RESOURCE',
    OTHER: 'OTHER'
};

Object.freeze(Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE);